import { Check } from "lucide-react";
import type { Product, ReceiptItem } from "../../types/receipt";
import { money } from "../../lib/finance";
import ItemFields, { comparisonLabel } from "./ReceiptItemFields";

/** One receipt line in the tracking step: what it was, its state, and its fields once picked. */
export default function ReceiptTrackingItem({ item, currency, products, status, isSelected, busy, onToggle, onChange }: {
  item: ReceiptItem;
  currency: string;
  products: Product[];
  status: "pending" | "saved" | undefined;
  isSelected: boolean;
  busy: boolean;
  onToggle: () => void;
  onChange: (patch: Partial<ReceiptItem>) => void;
}) {
  return (
    <article className="receipt-item">
      <div className="receipt-track-row">
        <span>
          <strong>{item.name || item.original}</strong>
          <small>
            {[
              item.quantity ? `${item.quantity} bought` : "",
              item.pack,
              comparisonLabel(item, currency),
            ]
              .filter(Boolean)
              .join(" · ")}
          </small>
          <small>
            {money(Number(item.total), currency)}
            {status === "saved"
              ? " · Tracked"
              : status === "pending"
                ? " · Check save"
                : ""}
          </small>
        </span>
        {status === "saved" ? (
          <Check size={18} />
        ) : status === "pending" ? (
          <span className="track-status">Pending</span>
        ) : (
          <button
            type="button"
            className="track-toggle"
            disabled={busy}
            onClick={onToggle}
          >
            {isSelected ? "Don’t track" : "Track price"}
          </button>
        )}
      </div>
      {isSelected && status !== "saved" && (
        <fieldset disabled={busy || !!status}>
          <ItemFields
            item={item}
            products={products}
            tracking
            change={onChange}
          />
        </fieldset>
      )}
    </article>
  );
}
